export type Step =
  | 'incoming'
  | 'inProcess'
  | 'outgoing'
  | 'scrapped'
  | 'shipped'

export const allSteps: Step[] = [
  'incoming',
  'inProcess',
  'outgoing',
  'scrapped',
  'shipped'
]
